export default __webpack_public_path__ + "static/media/semsPortalImg.94026851.png";